<template>
  <div class="fmt-tool">
    <div class="fmt-toolbar">
      <span class="fmt-label">{{ $t('tool.HtmlEntity.title') }}</span>
      <span class="fmt-spacer" />
      <el-button size="small" icon="el-icon-s-operation" type="primary" @click="encode">{{ $t("common.action.encode") }}</el-button>
      <el-button size="small" icon="el-icon-s-operation" @click="decode">{{ $t("common.action.decode") }}</el-button>
      <el-button size="small" @click="format">{{ $t("common.action.format") }}</el-button>
      <el-button size="small" @click="compress">{{ $t("common.action.compress") }}</el-button>
      <el-button size="small" plain icon="el-icon-document-copy" @click="doCopy">{{ $t("common.action.copy") }}</el-button>
      <el-button size="small" plain icon="el-icon-delete" @click="clearAll">{{ $t("common.action.clear") }}</el-button>
    </div>
    <el-input v-model="code" type="textarea" :rows="18" :placeholder="$t('tool.HtmlEntity.phInput')"
      class="fmt-textarea" @input="onInput" />
    <div class="fmt-status-bar">
      <span v-if="errorMsg" class="fmt-err"><i class="el-icon-warning" /> {{ errorMsg }}</span>
      <span v-else-if="lastOp" class="fmt-ok"><i class="el-icon-circle-check" /> {{ lastOp }}</span>
      <span v-else-if="code.trim()" class="fmt-ok"><i class="el-icon-circle-check" /> {{ charCount }}</span>
      <span v-else class="fmt-hint">{{ $t('tool.HtmlEntity.hint') }}</span>
    </div>
  </div>
</template>

<script>
// HTML void elements that don't need closing tags
var voidElements = {
  area:1, base:1, br:1, col:1, embed:1, hr:1, img:1, input:1,
  link:1, meta:1, param:1, source:1, track:1, wbr:1
}

export default {
  name:'HtmlEntityTool', props:{ config:{ type:Object, default:()=>({}) } },
  data:function(){
    return { code:'', errorMsg:'', lastOp:'' }
  },
  computed:{
    charCount:function(){ return this.code.length + ' ' + this.$t('tool.HtmlEntity.chars') }
  },
  methods:{
    onInput:function(){ this.errorMsg = ''; this.lastOp = '' },
    encode:function(){
      this.errorMsg = ''; this.lastOp = ''
      if (!this.code.trim()) return
      this.code = this.code.replace(/[&<>"']/g, function(c){
        return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]
      })
      this.lastOp = this.$t('tool.HtmlEntity.encoded')
    },
    decode:function(){
      this.errorMsg = ''; this.lastOp = ''
      if (!this.code.trim()) return
      var t = document.createElement('textarea')
      t.innerHTML = this.code
      this.code = t.value
      this.lastOp = this.$t('tool.HtmlEntity.decoded')
    },
    format:function(){
      this.errorMsg = ''; this.lastOp = ''
      if (!this.code.trim()) return
      try {
        this.code = this._beautify(this.code)
        this.lastOp = this.$t('tool.HtmlEntity.formatted')
      } catch(e) { this.errorMsg = e.message }
    },
    compress:function(){
      this.errorMsg = ''; this.lastOp = ''
      if (!this.code.trim()) return
      try {
        this.code = this._minify(this.code)
        this.lastOp = this.$t('tool.HtmlEntity.compressed')
      } catch(e) { this.errorMsg = e.message }
    },
    // ── beautify ──
    _beautify:function(html){
      var self = this
      var doc = new DOMParser().parseFromString(html, 'text/html')
      var out = '<!DOCTYPE html>\n'
      out += self._fmtNode(doc.documentElement, 0)
      return out.trim()
    },
    _fmtNode:function(node, depth){
      var indent = '  '.repeat(depth)
      var tag = node.tagName ? node.tagName.toLowerCase() : ''
      // text node
      if (node.nodeType === 3) {
        var t = node.textContent.replace(/\s+/g, ' ')
        return t.trim() ? indent + t.trim() + '\n' : ''
      }
      // comment node
      if (node.nodeType === 8) return indent + '<!--' + node.textContent + '-->\n'
      // element node
      if (!tag) {
        var s = ''
        for (var i = 0; i < node.childNodes.length; i++) { s += this._fmtNode(node.childNodes[i], depth) }
        return s
      }
      // build opening tag
      var open = '<' + tag
      if (node.attributes && node.attributes.length) {
        for (var j = 0; j < node.attributes.length; j++) {
          var a = node.attributes[j]
          open += ' ' + a.name + '="' + a.value.replace(/&/g,'&amp;').replace(/"/g,'&quot;') + '"'
        }
      }
      // void elements
      if (voidElements[tag]) return indent + open + '>\n'
      // collect children
      var children = ''
      for (var k = 0; k < node.childNodes.length; k++) {
        children += this._fmtNode(node.childNodes[k], depth + 1)
      }
      if (!children.trim()) {
        return indent + open + '></' + tag + '>\n'
      }
      // single text child — inline
      var nonEmpty = []
      for (var m = 0; m < node.childNodes.length; m++) {
        if (node.childNodes[m].nodeType === 3 && node.childNodes[m].textContent.trim()) nonEmpty.push(node.childNodes[m])
        else if (node.childNodes[m].nodeType === 1) nonEmpty.push(node.childNodes[m])
      }
      if (nonEmpty.length === 1 && nonEmpty[0].nodeType === 3) {
        return indent + open + '>' + nonEmpty[0].textContent.trim() + '</' + tag + '>\n'
      }
      return indent + open + '>\n' + children + indent + '</' + tag + '>\n'
    },
    // ── minify ──
    _minify:function(html){
      // remove comments
      html = html.replace(/<!--[\s\S]*?-->/g, '')
      // preserve whitespace in <pre>, <textarea>, <script>, <style>
      var preserved = []
      html = html.replace(/(<(pre|textarea|script|style)[^>]*>)([\s\S]*?)(<\/\2>)/gi, function(m, open, tag, body, close){
        preserved.push(body)
        return open + '___PRESERVE_' + (preserved.length - 1) + '___' + close
      })
      // collapse whitespace between tags
      html = html.replace(/>\s+</g, '><')
      // trim leading/trailing whitespace
      html = html.trim()
      // restore preserved blocks
      html = html.replace(/___PRESERVE_(\d+)___/g, function(m, idx){
        return preserved[parseInt(idx)]
      })
      return html
    },
    doCopy:function(){
      if (!this.code.trim()) { this.$message.warning(this.$t("common.status.noContent")); return }
      navigator.clipboard.writeText(this.code).then(this.$message.success(this.$t("common.status.copied")))
    },
    clearAll:function(){ this.code = ''; this.errorMsg = ''; this.lastOp = '' },
    doAction:function(a){
      if (a === 'copy') this.doCopy()
      if (a === 'clear') this.clearAll()
    }
  }
}
</script>

<style scoped>
.fmt-tool { display: flex; flex-direction: column; gap: 12px; }

.fmt-toolbar { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.fmt-toolbar >>> .el-button + .el-button { margin-left: 0; }
.fmt-label { font-size: 13px; font-weight: 700; color: #1a1f36; }
.fmt-spacer { flex: 1; }

.fmt-textarea >>> textarea {
  font-family: 'JetBrains Mono','Fira Code','Consolas',monospace !important;
  font-size: 13px !important; line-height: 1.6 !important;
  border-radius: 10px; resize: vertical; min-height: 360px;
}

.fmt-status-bar { font-size: 12px; }
.fmt-err { color: #f56c6c; display: flex; align-items: center; gap: 4px; }
.fmt-ok { color: #67c23a; display: flex; align-items: center; gap: 4px; }
.fmt-hint { color: #c0c4cc; }
</style>
